<template>
  <div class="d-flex mt-16 align-center justify-center">
    <v-progress-circular v-if="!error" indeterminate :size="50" />
    <BaseParagraph class="error--text" v-else>
      Une erreur s'est produite
    </BaseParagraph>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import BaseParagraph from '../components/BaseParagraph.vue';

export default {
  name: 'CasCallback',
  components: {
    BaseParagraph,
  },
  created() {
    const { ticket } = this.$route.query;
    this.validateTicket(ticket).catch(() => {
      this.error = true;
    });
  },
  data() {
    return {
      error: false,
    };
  },
  methods: mapActions(['validateTicket']),
};
</script>
